import { render, staticRenderFns } from "./SocialMarketingHBF.vue?vue&type=template&id=44e49f52&scoped=true"
import script from "./SocialMarketingHBF.vue?vue&type=script&lang=js"
export * from "./SocialMarketingHBF.vue?vue&type=script&lang=js"
import style0 from "./SocialMarketingHBF.vue?vue&type=style&index=0&id=44e49f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e49f52",
  null
  
)

export default component.exports